import { request, RequestConfig } from './request';

export const del = (config: RequestConfig) => request('delete', config);
export const get = (config: RequestConfig) => request('get', config);
export const post = (config: RequestConfig) => request('post', config);
export const put = (config: RequestConfig) => request('put', config);
export const patch = (config: RequestConfig) => request('patch', config);
